<fn-modal-header class="modal-header">
  <h5 class="modal-title" mat-dialog-title>MQBroker Entity</h5>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</fn-modal-header>
<mat-dialog-content>
  <div class="row">
    <div class="col-6">
      <label for="Name">HostName</label>
      <fn-base-input
        placeholder="Host name"
        [(ngModel)]="objectHash.hostName"
        [ngModelOptions]="{ standalone: true }"
      ></fn-base-input>
    </div>
    <div class="col-6">
      <label for="Name">BrokerName</label>
      <fn-base-input
        placeholder="Broker Name"
        [(ngModel)]="objectHash.brokerName"
        [ngModelOptions]="{ standalone: true }"
      ></fn-base-input>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <label for="Name">JMX Connector Port</label>
      <fn-base-input
        placeholder="JMX COnnector Port"
        [(ngModel)]="objectHash.jmxConnectorPort"
        [ngModelOptions]="{ standalone: true }"
      ></fn-base-input>
    </div>
    <div class="col-6">
      <label for="Name">JMX Domain Name</label>
      <fn-base-input
        placeholder="JMX Domain Name"
        [(ngModel)]="objectHash.jmxDomainName"
        [ngModelOptions]="{ standalone: true }"
      ></fn-base-input>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <label for="isUseJmx" class="form-label">Is Use JMX</label>
      <div>
        <fn-switch
          [(ngModel)]="objectHash.isUseJmx"
          [name]="'isUseJmx'"
        ></fn-switch>
      </div>
    </div>
    <div class="col-6">
      <label for="isActive" class="form-label">isActive</label>
      <div>
        <fn-switch
          [(ngModel)]="objectHash.isActive"
          [name]="'isActive'"
        ></fn-switch>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <label for="Name">JMX User Name</label>
      <fn-base-input
        placeholder="JMX User Name"
        [(ngModel)]="objectHash.jmxUserName"
        [ngModelOptions]="{ standalone: true }"
      ></fn-base-input>
    </div>
    <div class="col-6">
      <label for="Name">JMX Password</label>
      <fn-base-input
        placeholder="JMX Password"
        [(ngModel)]="objectHash.jmxPhash"
        [ngModelOptions]="{ standalone: true }"
      ></fn-base-input>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <label for="Name">User Name</label>
      <fn-base-input
        placeholder="User Name"
        [(ngModel)]="objectHash.userName"
        [ngModelOptions]="{ standalone: true }"
      ></fn-base-input>
    </div>
    <div class="col-6">
      <label for="Name">Password</label>
      <fn-base-input
        placeholder="Password"
        [(ngModel)]="objectHash.pssHash"
        [ngModelOptions]="{ standalone: true }"
      ></fn-base-input>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row">
    <div class="col-6 text-left">
      <button class="btn btn-danger float-left btn-round" (click)="close()">
        Cancel
      </button>
    </div>
    <div class="col-6 text-right">
      <button class="btn btn-primary float-right btn-round" (click)="add()">
        {{ isEdit ? "Update" : "Add" }}
      </button>
    </div>
  </div>
</mat-dialog-actions>
